import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export default makeStyles({
  container: {
    padding: '25px 50px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '80px',
    background: theme.palette.turmeric.main,
  },

  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '20px',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-start',
    },
  },

  imgWrapper: {
    flexShrink: 0,
    position: 'relative',
    width: '200px',
    height: '200px',

    [theme.breakpoints.up('md')]: {
      width: '250px',
      height: '250px',
    },

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});
